import { DateTime, Duration } from 'luxon';

import { getUtcDayTime } from './get-utc-day-time/get-utc-day-time';
import { getUTCNow } from './utc-now';

type DateRange = { from: string; to: string };

/**
 * Calculate date range for day-based filters.
 * Returns `from` as start of day N days ago (00:00:00 UTC)
 * and `to` as end of current UTC day (23:59:59.999 UTC).
 */
export function getDayBasedRange(days: number): DateRange {
  const now = DateTime.utc();
  const from = now.minus(Duration.fromObject({ days })).startOf('day');
  const to = now.endOf('day');

  return {
    from: from.toISO({ suppressMilliseconds: true }) || '',
    to: to.toISO({ suppressMilliseconds: true }) || '',
  };
}

export function getDateRangeBasedOnCreationDate(creationDate: Date): DateRange {
  const to = getUTCNow();
  const from = getUtcDayTime(creationDate);
  return {
    from,
    to,
  };
}

/**
 * Calculate date range for hour-based filters.
 * Returns `to` as current UTC datetime and `from` as UTC datetime N hours before,
 * rounded down to the start of the hour.
 */
export function getHourBasedRange(hours: number): DateRange {
  const to = DateTime.utc();
  const from = to.minus(Duration.fromObject({ hours })).startOf('hour');

  return {
    from: from.toISO({ suppressMilliseconds: true }) || '',
    to: to.toISO({ suppressMilliseconds: true }) || '',
  };
}

export function getMonthBasedRange(months: number): DateRange {
  const now = DateTime.utc();
  const from = now.minus(Duration.fromObject({ months })).startOf('day');
  const to = now.endOf('day');

  return {
    from: from.toISO({ suppressMilliseconds: true }) || '',
    to: to.toISO({ suppressMilliseconds: true }) || '',
  };
}
